// @flow
import CardPassages from './CardPassages';

export default CardPassages;
